import common from './zh-CN/common';
import tools from './zh-CN/tools';
import upload from './zh-CN/upload';
import report from './zh-CN/report-summary';
import text2sql from './zh-CN/text2sql';
import gptTranslator from './zh-CN/gptTranslator';
import dataAnalysis from './zh-CN/dataAnalysis';
import motionCapture from './zh-CN/motion-capture';
import agentChat from './zh-CN/agentChat';
export default {
  ...common,
  ...tools,
  ...upload,
  ...report,
  ...text2sql,
  ...gptTranslator,
  ...dataAnalysis,
  ...motionCapture,
  ...agentChat,
};
